import { AgreementType, SizeInfoAction, useSizeInfoChannelListener } from '@widgets/size-broadcast-channel';

import { usePendingSizeInput } from '../queries/usePendingSizeInputQuery';

export interface AgreeSizeInfoPayload {
  is_agreed: boolean;
  type?: AgreementType;
}

export interface UseSizeInfoAgreementListenerProps {
  onAgree: (payload: AgreeSizeInfoPayload) => void;
  onSelectMyPurchase: (catalogProductId: string, uniqueKey: string) => void;
  onCompareDirectInput: () => void;
}

export const useSizeInfoAgreementListener = ({
  onAgree,
  onSelectMyPurchase,
  onCompareDirectInput,
}: UseSizeInfoAgreementListenerProps) => {
  const { clearPending } = usePendingSizeInput();

  useSizeInfoChannelListener((message) => {
    if (message.action === SizeInfoAction.AGREE_SIZE_INFO) {
      if (message.payload.is_agreed) {
        onAgree(message.payload);
      } else {
        clearPending();
      }
    }

    if (message.action === SizeInfoAction.SELECT_MY_PURCHASE) {
      onSelectMyPurchase(message.payload.catalog_product_id, message.payload.unique_key);
    }

    if (message.action === 'COMPARE_DIRECT_INPUT') {
      onCompareDirectInput();
    }
  });
};
